import type { ChannelNavChannel } from '~publish/components/PublishSidebar/useChannels'

// Matches the single-channel schedule route exactly (e.g. `/channels/abc/schedule`),
// not its sub-routes (`/schedule/new`, `/schedule/:postId`). Keeps the launch
// dialog off the composer/post-detail views the schedule page nests via `Outlet`.
const CHANNEL_SCHEDULE_PATH_REGEX = /^\/channels\/([^/]+)\/schedule\/?$/

/**
 * Derives the channel id the LinkedIn Capabilities launch dialog should target,
 * or `null` when it shouldn't appear.
 *
 * Keyed off the router's `useParams().id` + `useLocation().pathname` rather than
 * `window.location`, so it re-derives reactively on client-side (SPA) navigation
 * between channel schedules — replacing app-shell's since-removed `window.__history` bridge.
 */
export function getLinkedInCapabilitiesLaunchChannelId({
  channelId,
  pathname,
  channels,
}: {
  channelId: string | undefined
  pathname: string
  channels: Pick<ChannelNavChannel, 'id' | 'service'>[]
}): string | null {
  if (!channelId || !CHANNEL_SCHEDULE_PATH_REGEX.test(pathname)) {
    return null
  }

  const channel = channels.find(({ id }) => id === channelId)

  return channel?.service === 'linkedin' ? channel.id : null
}
